import React from 'react'
import './style.css'
import CirclePlus from '../../_common/_icons/CirclePlus'
import CircleMinus from '../../_common/_icons/CircleMinus'
import NRTButton from '../../_common/_buttons/Button'

class CourseExcerpt extends React.Component {
    state = {
        showMoreButton: true,
        divContentHeight: '100%',
        truncated: true
    }

    toggleTruncated = () => {
        this.setState({
            truncated: !this.state.truncated
        })
    }


    componentDidMount() {
       this.setDivHeight()
    }



    setDivHeight() {
        if (this.divContent) {
            setTimeout(() => {
                const divContentHeight = this.divContent.clientHeight + 200

                this.setState({
                    divContentHeight,
                    showMoreButton: divContentHeight > 300,
                    trucated: divContentHeight > 300
                })
            }, 200)
        }

    }


    render() {
        const { truncated, showMoreButton, divContentHeight } = this.state

        return (
            <div
                className="course-exerpt container"
                style={{
                    maxWidth: '100vw',
                    maxHeight: truncated ? '25rem' : divContentHeight + 'px'
                }}
            >
                <div className="html-content" ref={el => (this.divContent = el)}
                     dangerouslySetInnerHTML={{ __html: this.props.html }}
                     style={{marginBottom:'1.5rem'}}


                />

                {showMoreButton && (
                    <div className="read-more-button-container">
                        <NRTButton
                            secondary
                            onClick={this.toggleTruncated}
                            style={{ height: '2.5rem' }}
                            content={
                                truncated ? (
                                    <div>
                                        <CirclePlus /> Mais
                                    </div>
                                ) : (
                                    <div>
                                        <CircleMinus /> Menos
                                    </div>
                                )
                            }
                        />
                    </div>
                )}
            </div>
        )
    }
}

CourseExcerpt.propTypes = {}

CourseExcerpt.defaultProps = {}

export default CourseExcerpt



// WEBPACK FOOTER //
// ./src/components/_courses/CourseExcerpt/index.js